import { render } from "./AllNotificationsPage.vue?vue&type=template&id=f48f4f48&scoped=true"
import script from "./AllNotificationsPage.vue?vue&type=script&lang=js"
export * from "./AllNotificationsPage.vue?vue&type=script&lang=js"

import "./AllNotificationsPage.vue?vue&type=style&index=0&id=f48f4f48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f48f4f48"]])

export default __exports__